import { useState } from "react";
import { useQrDecoder } from "../../../Hooks/useQrDecoder";
import "./style.css";
import { QrCodeIcon } from "../../../Assets/images/svgs";
import { TextInput } from "../../Atoms";

export default function ImeiCard({ onMapDevice }) {
  const [imei, setImei] = useState("");
  const [error, setError] = useState("");
  const [preview, setPreview] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const { decodeFile } = useQrDecoder();

  const handleUploadQR = async (e) => {
    setSubmitted(false);
    const file = e.target.files?.[0];
    if (!file) return;
    const previewUrl = URL.createObjectURL(file);
    setPreview(previewUrl);

    const payload = await decodeFile(file);
    if (!payload) {
      setPreview(null);
      setSubmitted(true);
      setImei("");
      setError("Failed to read QR code");
      return;
    }

    try {
      const [imeiPart] = payload.trim().split(/\s+/);
      const isValidImei = /^\d{15}$/.test(imeiPart);

      if (isValidImei) setImei(imeiPart);
      else setError("Invalid IMEI");
    } catch {
      const match = payload.match(/\b\d{15}\b/);
      if (match && match[0]) setImei(match[0]);
      else setError("Invalid IMEI");
    }

    e.target.value = "";
  };

  const validateImei = (value) => {
    if (!value) return "";
    if (!/^\d+$/.test(value)) return "IMEI must contain only numbers.";
    if (value.length !== 15) return "IMEI must be 15 digits long.";
    return "";
  };

  const handleMapDevice = () => {
    setSubmitted(true);
    const err = validateImei(imei);
    setError(err);

    if (err || !imei.trim()) return;
    if (onMapDevice) onMapDevice(imei);
  };

  return (
    <div className={`imei-card ${preview ? "wide" : ""}`}>
      <div className="left-section">
        <h3 className="imei-title">Enter IMEI Number</h3>

        <TextInput
          inputName="imei"
          placeholder="123456789012345"
          className="add-vehicle-text-field"
          labelClassName="add-vehicle-text-field-label"
          errMessage={submitted ? error : ""}
          onChange={(val) => setImei(val.trim())}
          value={imei}
          isRequired={true}
        />

        <button
          className="imei-card-btn imei-card-btn-primary"
          onClick={handleMapDevice}
          disabled={imei.length !== 15}
          style={{
            opacity: imei.length === 15 ? 1 : 0.5,
            pointerEvents: imei.length === 15 ? "auto" : "none",
          }}
        >
          Map Device
        </button>

        <label className="imei-card-btn imei-card-btn-secondary upload-btn">
          <input type="file" accept="image/*" onChange={handleUploadQR} hidden />
          <QrCodeIcon className="qr-icon" />
          Upload QR Code
        </label>
      </div>

      {preview && (
        <div className="right-section">
          <img src={preview} alt="QR preview" className="fade-in" />
        </div>
      )}
    </div>
  );
}